import _asyncToGenerator from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/regenerator/index.js";
/* eslint-disable consistent-return */
import Web3 from 'web3';
import isMobile from '../../detectMobile';
import { later } from '../../timers';
import networkDetails from './networks';

// eslint-disable-next-line import/no-mutable-exports
var metamask;

// eslint-disable-next-line func-names
(function (win) {
  var connectPromise;
  metamask = {
    isInstalled: function isInstalled() {
      if (!isMobile) {
        return Promise.resolve(!!win.ethereum && win.ethereum.isMetaMask);
      }
      return new Promise(function (resolve) {
        var handleEthereumCheck = function handleEthereumCheck() {
          resolve(!!win.ethereum && win.ethereum.isMetaMask);
        };
        if (win.addEventListener) {
          win.addEventListener('ethereum#initialized', handleEthereumCheck, {
            once: true
          });
        }
        // If the event is not dispatched by the end of the timeout,
        // the user probably doesn't have MetaMask installed.
        setTimeout(handleEthereumCheck, 3000); // 3 seconds
      });
    },

    getMetaMask: function () {
      var _getMetaMask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var isInstalled;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return metamask.isInstalled();
            case 2:
              isInstalled = _context.sent;
              return _context.abrupt("return", isInstalled && win.ethereum);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getMetaMask() {
        return _getMetaMask.apply(this, arguments);
      }
      return getMetaMask;
    }(),
    isConnected: function () {
      var _isConnected = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", metamask.connect().then(function (val) {
                return !!val;
              }).catch(function () {
                return false;
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function isConnected() {
        return _isConnected.apply(this, arguments);
      }
      return isConnected;
    }(),
    getChainId: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var mm;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return metamask.getMetaMask();
            case 2:
              mm = _context3.sent;
              if (mm) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              return _context3.abrupt("return", Web3.utils.hexToNumber(mm.chainId));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getChainId() {
        return _getChainId.apply(this, arguments);
      }
      return getChainId;
    }(),
    getAddress: function () {
      var _getAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var mm;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return metamask.isConnected();
            case 2:
              if (_context4.sent) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _context4.next = 6;
              return metamask.getMetaMask();
            case 6:
              mm = _context4.sent;
              return _context4.abrupt("return", mm.selectedAddress);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getAddress() {
        return _getAddress.apply(this, arguments);
      }
      return getAddress;
    }(),
    getAccounts: function () {
      var _getAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var address;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return metamask.getAddress();
            case 2:
              address = _context5.sent;
              return _context5.abrupt("return", address ? [address] : []);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getAccounts() {
        return _getAccounts.apply(this, arguments);
      }
      return getAccounts;
    }(),
    sendTx: function () {
      var _sendTx = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var rawTx,
          mm,
          _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              rawTx = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
              _context6.next = 3;
              return metamask.getMetaMask();
            case 3:
              mm = _context6.sent;
              if (mm) {
                _context6.next = 6;
                break;
              }
              throw new Error('MetaMask is not installed');
            case 6:
              delete rawTx.gasLimit; // cannot be used
              return _context6.abrupt("return", mm.request({
                method: 'eth_sendTransaction',
                params: [rawTx]
              }));
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function sendTx() {
        return _sendTx.apply(this, arguments);
      }
      return sendTx;
    }(),
    switchToNetwork: function () {
      var _switchToNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(chainId) {
        var mm;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (networkDetails[chainId]) {
                _context7.next = 3;
                break;
              }
              // eslint-disable-next-line no-console
              console.debug('useMetamask switchToNetwork -> chainId', chainId, 'is not defined by @itsa.io/web3utils');
              return _context7.abrupt("return");
            case 3:
              _context7.next = 5;
              return metamask.getMetaMask();
            case 5:
              mm = _context7.sent;
              if (mm) {
                _context7.next = 8;
                break;
              }
              throw new Error('MetaMask is not installed');
            case 8:
              _context7.prev = 8;
              _context7.next = 11;
              return mm.request({
                method: 'wallet_switchEthereumChain',
                params: [{
                  chainId: networkDetails[chainId].chainId
                }]
              });
            case 11:
              _context7.next = 18;
              break;
            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7["catch"](8);
              if (!(_context7.t0.code === 4902)) {
                _context7.next = 17;
                break;
              }
              return _context7.abrupt("return", mm.request({
                method: 'wallet_addEthereumChain',
                params: [networkDetails[chainId]]
              }));
            case 17:
              throw new Error(_context7.t0);
            case 18:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[8, 13]]);
      }));
      function switchToNetwork(_x) {
        return _switchToNetwork.apply(this, arguments);
      }
      return switchToNetwork;
    }(),
    disconnect: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              console.warn('useMetamask disconnect() is not supported anymore');
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function disconnect() {
        return _disconnect.apply(this, arguments);
      }
      return disconnect;
    }(),
    connect: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var connectedValue, mm;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!connectPromise) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return", connectPromise);
            case 2:
              _context10.prev = 2;
              _context10.next = 5;
              return metamask.getMetaMask();
            case 5:
              mm = _context10.sent;
              connectPromise = new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(resolve, reject) {
                  var response;
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.prev = 0;
                        later(function () {
                          reject('MetaMask timeout');
                        }, 2000);
                        _context9.next = 4;
                        return mm.request({
                          method: 'eth_requestAccounts'
                        });
                      case 4:
                        response = _context9.sent;
                        resolve(response);
                        _context9.next = 11;
                        break;
                      case 8:
                        _context9.prev = 8;
                        _context9.t0 = _context9["catch"](0);
                        reject(_context9.t0);
                      case 11:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9, null, [[0, 8]]);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context10.next = 9;
              return connectPromise;
            case 9:
              connectedValue = connectPromise;
              connectPromise = null;
              _context10.next = 17;
              break;
            case 13:
              _context10.prev = 13;
              _context10.t0 = _context10["catch"](2);
              connectedValue = null;
              connectPromise = null;
            case 17:
              return _context10.abrupt("return", connectedValue);
            case 18:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[2, 13]]);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
  };
})(typeof global !== 'undefined' ? global : /* istanbul ignore next */this);
export default metamask;